import React, { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Box, Button, Chip, Typography } from '@mui/material'
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents'
import { Colors } from '../../../../Styles/Colors'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService'
import Loader from '../../../../Components/Loader';
import { Chart as ChartJS, LinearScale, CategoryScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom'
import { Line } from 'react-chartjs-2'
import { Growth_chart } from '../../../../Utility/Constants'
import { getStandardGrowthCurves } from '../../../../Utility/GrowthChartReferenceData'

ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Filler, Tooltip, Legend, zoomPlugin)
export default class DocGrowthChart extends Component {
    constructor(props) {
        super(props)
        this.chartRef = React.createRef();
        this.state = {
            patientDetails: {},
            filterItem: Growth_chart,
            filter_data: 'height',
            growthChart: [],
            data: {
                labels: [],
                datasets: []
            },
            growthTooltipData: [],
            chartYMin: null,
            chartYMax: null,
            ageGroup: null,
        }
    }

    resetChartZoom = () => {
        try {
            const chart = this.chartRef.current;
            if (chart && typeof chart.resetZoom === 'function') {
                chart.resetZoom();
            }
        } catch (e) { /* ignore */ }
    }

    componentDidMount() {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        this.setState({
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id
        }, () => {
            this.getPatientDetailData();
        })
    }

    getPatientDetailData = () => {
        this.LoaderFunction(true)
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.LoaderFunction(false)
                        this.setState({
                            patientDetails: response?.data?.data
                        }, () => {
                            this.getGrowthchart();
                        });
                    } else {
                        this.LoaderFunction(false)
                        this.getGrowthchart();
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.getGrowthchart();
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
            this.getGrowthchart();
        }
    }

    getGrowthchart = () => {
        this.LoaderFunction(true)
        try {
            RestAPIService.getAll(Serviceurls.PD_GROWTH_CHART + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.LoaderFunction(false)
                        this.setState({
                            growthChart: response?.data?.data
                        }, () => {
                            this.setPlotHeightChart(response?.data?.data, this.state.filter_data);
                        })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    setPlotHeightChart(response, type, ageGroup = null) {

        let patientGrowth = response.patient_growth || {};
        let patient = response.patient || {};

        let patientData;
        var gender = (response.patient && response.patient.gender) ? response.patient.gender : 'm';
        var refData = getStandardGrowthCurves(gender, type);
        var standardCurves = refData.curves || [];
        var refAges = refData.ages || [];

        if (type === "height") {
            patientData = patientGrowth && patientGrowth.height ? patientGrowth.height : [];
        }
        else if (type === "weight") {
            patientData = patientGrowth && patientGrowth.weight ? patientGrowth.weight : [];
        }
        else if (type === "bmi") {
            patientData = patientGrowth && patientGrowth.bmi ? patientGrowth.bmi : [];
        }
        else if (type === "head circumference") {
            patientData = patientGrowth && patientGrowth.head_circumference ? patientGrowth.head_circumference : [];
        }

        var dataFields = this.state.data;

        let age = "";
        if (patient) {
            let dataArr = (patient?.age)?.split(",");
            let lenArr = dataArr?.length;
            if (lenArr > 0) {
                age = parseInt(dataArr[0], 10);
                let m = parseInt(dataArr[1], 10);
                let d = parseInt(dataArr[2], 10);
                if (m > 0 || d > 0) {
                    age = age + 1;
                }
            }
        }
        let patientAge = age;

        // For height/weight: determine which age group to display.
        // Use raw year value (no +1 rounding) so 5Y 11M stays in '0-5', not '6-18'.
        var isHeightOrWeight = type === 'height' || type === 'weight';
        var selectedGroup = null;
        if (isHeightOrWeight) {
            var rawAgeYears = parseInt(((patient?.age) || '').split(',')[0], 10);
            if (isNaN(rawAgeYears)) rawAgeYears = 0;
            selectedGroup = ageGroup || (rawAgeYears < 6 ? '0-5' : '6-18');
        }

        var ageArray = refAges;
        var refValueLen = ageArray.length;

        var referenceCurves = standardCurves.length > 0
            ? standardCurves.map(function (item, i) {
                var color = (i === 0 || i === 4) ? '#cc33ff' : (i === 1 || i === 3) ? '#00ccff' : (i === 2) ? '#00ff99' : '#ff0066';
                var points = ageArray.map(function (age, idx) {
                    return { x: age, y: item.value[idx] };
                });
                if (isHeightOrWeight) {
                    points = points.filter(function (pt) {
                        return selectedGroup === '0-5' ? pt.x <= 5 : pt.x > 5;
                    });
                }
                return {
                    label: item.label,
                    data: points,
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    borderColor: color,
                    borderWidth: 1.5,
                    fill: false,
                    lineTension: 0.4,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                };
            })
            : [];

        var stringOne = "Length / height for age";
        var stringTwo = patient && patient.gender === "m" ? " Boys " : " Girls ";
        var stringThree = refValueLen > 61 ? "0-18 years" : (patientAge <= 5 ? "0-5 years" : "5-19 years");
        var stringFour = " (Percentile)";
        dataFields.datasets = referenceCurves;

        var patient_record_count = patientGrowth && patientGrowth.age ? patientGrowth.age.length : 0;
        var patientDetails = this.state.patientDetails || {};
        var dob = patient?.dob || patientDetails?.dob;
        var appointmentDate = patientDetails?.appointment_date || '';
        var lastVisitDate = patientDetails?.last_visit_date || '';

        var visitDatesFromApi = patientGrowth && patientGrowth.visit_date ? patientGrowth.visit_date : null;
        var patientPointsWithTooltip = [];
        for (var i = 0; i < patient_record_count; i++) {
            const ageVal = patientGrowth.age[i]; // age stored in years
            if (ageVal == null || isNaN(ageVal)) continue;
            var visitDateFromApi = visitDatesFromApi && visitDatesFromApi[i] != null ? visitDatesFromApi[i] : null;
            var visitDate = this.getVisitDateForTooltip(i, patient_record_count, dob, appointmentDate, lastVisitDate, patientGrowth.age[i], visitDateFromApi);
            var ageAtVisit = this.formatAgeAtVisit(ageVal);
            var paramLabel = this.getParamLabel(type);
            if (patientData[i] > 0) {
                patientPointsWithTooltip.push({
                    x: ageVal,
                    y: patientData[i],
                    tooltipInfo: { visitDate, ageAtVisit, value: patientData[i], paramLabel }
                });
            }
        }
        patientPointsWithTooltip.sort(function (a, b) { return a.x - b.x; });

        // Filter patient points by age group for height/weight
        if (isHeightOrWeight) {
            patientPointsWithTooltip = patientPointsWithTooltip.filter(function (p) {
                return selectedGroup === '0-5' ? p.x <= 5 : p.x > 5;
            });
        }

        var patientDataPoints = patientPointsWithTooltip.map(function (p) { return { x: p.x, y: p.y }; });
        var tooltipDataArr = patientPointsWithTooltip.map(function (p) { return p.tooltipInfo; });

        var patient_height_dataset = {
            label: type,
            data: patientDataPoints,
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: '#1a56db',
            fill: false,
            lineTension: 0,
            type: 'line',
            borderWidth: 3,
            pointRadius: 6,
            pointHoverRadius: 8,
            pointBackgroundColor: '#1a56db',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
        };

        dataFields.datasets.push(patient_height_dataset);
        dataFields.labels = [];

        var yMin = Infinity, yMax = -Infinity;
        referenceCurves.forEach(function (curve) {
            (curve.data || []).forEach(function (pt) {
                var v = pt && pt.y != null ? Number(pt.y) : NaN;
                if (!isNaN(v)) { yMin = Math.min(yMin, v); yMax = Math.max(yMax, v); }
            });
        });
        patientDataPoints.forEach(function (pt) {
            var v = pt && pt.y != null ? Number(pt.y) : NaN;
            if (!isNaN(v)) { yMin = Math.min(yMin, v); yMax = Math.max(yMax, v); }
        });
        if (yMin === Infinity) yMin = 0;
        if (yMax === -Infinity) yMax = 100;
        var padding = Math.max((yMax - yMin) * 0.05, 1);
        var chartYMin = Math.max(0, yMin - padding);
        var chartYMax = yMax + padding;

        this.setState({
            dataFields,
            commonString: stringOne + stringTwo,
            ageString: stringThree + stringFour,
            growthTooltipData: tooltipDataArr,
            chartYMin,
            chartYMax,
            ...(isHeightOrWeight ? { ageGroup: selectedGroup } : {}),
        });
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    returnchartText(text){
        switch(text){
            case "height" : return "Height_(cms)"
            case "weight" : return "Weight_(Kgs)"
            case "bmi" : return "BMI"
            case "head circumference" : return "Head_Circumference_(cms)"
            default : return ""
        }
    }

    getParamLabel(type) {
        switch (type) {
            case 'height': return 'Height (cm)';
            case 'weight': return 'Weight (kg)';
            case 'bmi': return 'BMI';
            case 'head circumference': return 'Head Circumference (cm)';
            default: return type;
        }
    }

    formatAgeAtVisit(ageInYears) {
        if (ageInYears == null || ageInYears === '') return '-';
        var y = Math.floor(ageInYears);
        var m = Math.round((ageInYears - y) * 12);
        if (y > 0 && m > 0) return y + ' yr ' + m + ' mo';
        if (y > 0) return y + ' yr';
        return m + ' mo';
    }

    formatDDMMYYYY(date) {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        var dd = d < 10 ? '0' + d : String(d);
        var mm = m < 10 ? '0' + m : String(m);
        return dd + '/' + mm + '/' + y;
    }

    getVisitDateForTooltip(patientIndex, totalPoints, dob, appointmentDate, lastVisitDate, ageInYears, visitDateFromApi) {
        if (visitDateFromApi != null && visitDateFromApi !== '') {
            try {
                var str = String(visitDateFromApi).trim();
                if (str.indexOf('-') !== -1) {
                    var parts = str.split('-');
                    if (parts.length === 3) {
                        var day = parseInt(parts[0], 10), month = parseInt(parts[1], 10) - 1, year = parseInt(parts[2], 10);
                        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                            var d = new Date(year, month, day);
                            if (!isNaN(d.getTime())) return this.formatDDMMYYYY(d);
                        }
                    }
                }
                var parsed = new Date(str);
                return isNaN(parsed.getTime()) ? str : this.formatDDMMYYYY(parsed);
            } catch (e) { return String(visitDateFromApi); }
        }
        if (patientIndex === totalPoints - 1) {
            if (appointmentDate) {
                try {
                    var d = new Date(appointmentDate);
                    return isNaN(d.getTime()) ? appointmentDate : this.formatDDMMYYYY(d);
                } catch (e) { return appointmentDate; }
            }
            if (lastVisitDate) {
                try {
                    var d = new Date(lastVisitDate);
                    return isNaN(d.getTime()) ? lastVisitDate : this.formatDDMMYYYY(d);
                } catch (e) { return lastVisitDate; }
            }
            return '-';
        }
        if (!dob || ageInYears == null) return '-';
        try {
            var birth = new Date(dob);
            if (isNaN(birth.getTime())) return '-';
            var monthsToAdd = Math.round(ageInYears * 12);
            var visit = new Date(birth.getFullYear(), birth.getMonth() + monthsToAdd, birth.getDate());
            return this.formatDDMMYYYY(visit);
        } catch (e) { return '-'; }
    }

    renderLeftSide = () => {
        let data = this.state.data;
        let growthTooltipData = this.state.growthTooltipData || [];
        let chartFont = "Open Sans";
        const is05Chart = this.state.filter_data === 'bmi' || this.state.filter_data === 'head circumference';
        const isHeightOrWeight = this.state.filter_data === 'height' || this.state.filter_data === 'weight';
        const xMin = isHeightOrWeight && this.state.ageGroup === '6-18' ? 6 : 0;
        const xMax = is05Chart ? 5 : (isHeightOrWeight && this.state.ageGroup === '0-5' ? 5 : 18);
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: true
              },
              title: {
                display: false
              },
              tooltip: {
                titleFont: { family: chartFont },
                bodyFont: { family: chartFont },
                callbacks: {
                  title: (context) => {
                    if (!context || !context.length) return '';
                    var isPatientDataset = data.datasets && context[0].datasetIndex === data.datasets.length - 1;
                    if (isPatientDataset && growthTooltipData[context[0].dataIndex]) {
                      var info = growthTooltipData[context[0].dataIndex];
                      return info.paramLabel + ': ' + info.value;
                    }
                    return context[0].dataset.label || '';
                  },
                  label: (context) => {
                    var isPatientDataset = data.datasets && context.datasetIndex === data.datasets.length - 1;
                    if (!isPatientDataset) {
                      var raw = context.raw;
                      return context.dataset.label + ': ' + (raw && typeof raw === 'object' && 'y' in raw ? raw.y : context.raw);
                    }
                    var raw = context.raw;
                    if (raw == null || (typeof raw === 'object' && raw.y == null)) return null;
                    var tooltipInfo = growthTooltipData[context.dataIndex];
                    if (!tooltipInfo) return context.dataset.label + ': ' + (typeof raw === 'object' ? raw.y : raw);
                    return [
                      'Visit Date: ' + tooltipInfo.visitDate,
                      'Age at Visit: ' + tooltipInfo.ageAtVisit,
                      tooltipInfo.paramLabel + ': ' + tooltipInfo.value,
                    ];
                  },
                },
              },
              zoom: {
                zoom: {
                  wheel: { enabled: true },
                  pinch: { enabled: true },
                },
                pan: {
                  enabled: true,
                  mode: 'xy',
                },
                limits: {
                  x: { min: xMin, max: xMax },
                  ...(this.state.chartYMin != null && this.state.chartYMax != null
                    ? { y: { min: this.state.chartYMin, max: this.state.chartYMax } }
                    : {}),
                },
              },
            },
            scales: {
              x: {
                type: 'linear',
                min: xMin,
                max: xMax,
                title: {
                  display: true,
                  text: 'Age (years)',
                  font: { family: chartFont, size: 12 }
                },
                grid: {
                  color: 'rgba(0, 0, 0, 0.08)',
                  drawTicks: true,
                },
                ticks: {
                  stepSize: 1,
                  font: {
                    weight: 'bold',
                    family: chartFont,
                    size: 12
                  }
                }
              },
              y: {
                grid: {
                  color: 'rgba(0, 0, 0, 0.08)',
                },
                ticks: {
                  align: 'center',
                  font: {
                    weight: 'bold',
                    family: chartFont
                  },
                }
              },
            },
            animations: {
              tension: {
                duration: 1000,
                easing: 'linear',
                from: 0.2,
                to: 0,
                loop: true
              }
            }
          };
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'} justifyContent={'space-between'} pr={'0.5vw'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Growth Chart</Typography>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={this.resetChartZoom}
                            sx={{ fontSize: '0.75vw', textTransform: 'none' }}
                        >
                            Reset zoom
                        </Button>
                    </Box>
                    <Box sx={{ backgroundColor: Colors.white, display: 'flex', alignItems:'center' }}>
                        <Box sx={{width:'2vw'}}>
                            <Typography sx={{ rotate: "270deg" }} >{this.returnchartText(this.state.filter_data)}</Typography>
                        </Box>
                        <Box component={'div'}  p={'0.5vw'} sx={{ height: '57vh', width:'57vw' }}>
                        <Line
                            ref={this.chartRef}
                            options={options}
                            data={data}
                        />
                    </Box>
                    </Box>
                    
                </Box>
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderRightSide = () => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Filter</Typography>
                    </Box>
                    <Box component={'div'} height={'25vw'} sx={{ backgroundColor: Colors.white }} overflow={'scroll'} p={'0.5vw'}>
                        <Box component={'div'}>
                            {this.state.filterItem?.map((item, index) => {
                                return (
                                    <Chip
                                        className={`eMed_chip ${(item.label).toLowerCase() === this.state.filter_data ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={item.label}
                                        variant={item.label === this.state.filter_data ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            this.setState({ filter_data: item?.value }, () => {
                                                this.getGrowthchart()
                                            })
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                )
                            })}
                        </Box>
                        {(this.state.filter_data === 'height' || this.state.filter_data === 'weight') && (
                            <Box component={'div'} mt={'0.8vw'}>
                                <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText} mb={'0.3vw'}>Age Group</Typography>
                                {[{ label: '0-5 Years', value: '0-5' }, { label: '6-18 Years', value: '6-18' }].map((ag, idx) => (
                                    <Chip
                                        key={idx}
                                        className={`eMed_chip ${this.state.ageGroup === ag.value ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={ag.label}
                                        variant={this.state.ageGroup === ag.value ? 'contained' : 'outlined'}
                                        clickable
                                        onClick={() => {
                                            this.setState({ ageGroup: ag.value }, () => {
                                                this.setPlotHeightChart(this.state.growthChart, this.state.filter_data, ag.value);
                                            });
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Box>
                </Box>
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    render() {
        let attender = {
            lineOne: "Attender Name",
            lineTwo: `${this.state.patientDetails?.attender_name ? this.state.patientDetails?.attender_name :
                this.state.patientDetails?.caretaker_name ? this.state.patientDetails?.caretaker_name : "-"}`,
            lineFour: 'Contact Number',
            LineFive: `${this.state.patientDetails?.attender_mobile ? this.state.patientDetails?.attender_mobile :
                this.state.patientDetails?.caretaker_mobile ? this.state.patientDetails?.caretaker_mobile : "-"}`
        }
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'78vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} />
                    </Box>
                    {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
                </Box>
                <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'62vh'}>
                    <Box component={'div'} flex={0.65} height={'66.5vh'} border={'1px solid lightgray'}>
                        {this.renderLeftSide()}
                    </Box>
                    <Box component={'div'} flex={0.35} border={'1px solid lightgray'} height={'66.5vh'} ml={'.5vw'}>
                        {this.renderRightSide()}
                    </Box>
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
